import React from "react";
import MainLayout from "../../../hoc/main";
import {Grid, TableData} from "../../../components";
import {connect} from "react-redux";
import {deleteAcBrandData, getAcBrandDatas,} from "../../../redux/modules/AcBrand/action";

class AcBrand extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            datas: [],
        };
    }

    componentDidMount() {
        this.props.getAcBrandDatas();
    }

    UNSAFE_componentWillReceiveProps(np) {
        this.setState({
            datas: np.acBrand.datas,
        });
    }

    render() {
        // console.log(this.state.datas);
        const acBrandColumn = [
            {
                name: "Access Brand",
                path: "name",
                show: true,
            },
        ];

        return (
            <div className="p-6 mt-20 xl:mt-0 ">
                <Grid>
                    <TableData
                        addData={true}
                        trashBin={true}
                        path={this.props.location.pathname}
                        title={"Access Brand Data"}
                        data={this.props.acBrand.datas}
                        columns={acBrandColumn}
                        action={["update", "delete"]}
                        trash={true}
                        deleteAction={(id) => this.props.deleteAcBrandData(id)}
                    />
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    acBrand: state.acBrand,
});

const mapDispatchToProps = {
    getAcBrandDatas,
    deleteAcBrandData,
};

export default MainLayout(
    connect(mapStateToProps, mapDispatchToProps)(AcBrand)
);
